import { z } from 'zod';

export const SUPPORTED_CURRENCIES = ['XCG'] as const;
export type Currency = (typeof SUPPORTED_CURRENCIES)[number];

export const currencySchema = z.enum(SUPPORTED_CURRENCIES);

export const CURRENCY_EXPONENTS: Readonly<Record<Currency, number>> = {
  XCG: 2,
};
